<template>
  <div class="qta_wrapper">
    <b-row>
      <b-col>선택지*</b-col>
    </b-row>
    <div :class="qtype3_valid_cls">
      <b-row :key="pick.id" v-for="pick in picks">
        <b-col sm="4" lg="4">
          <BogiEditor :content="pick.text" :func="pick.myf1" />
        </b-col>
        <b-col
          lg="2"
          sm="2"
          v-if="q_type_sub == '1' || q_type_sub == '3' || q_type_sub == '4'"
        >
          <b-form-checkbox style="text-align: center" v-model="pick.sub"
            >정답</b-form-checkbox
          >
        </b-col>
        <b-col sm="4" lg="4" v-if="q_type_sub > 1">
          <BogiEditor :content="pick.answer" :func="pick.myf2" />
        </b-col>

        <b-col lg="2" sm="2">
          <b-button
            class="float-left"
            size="sm"
            variant="danger"
            @click="removePick(pick)"
            >D</b-button
          >
        </b-col>
      </b-row>
    </div>
    <b-row :class="nocount_qtype3_valid_cls">
      <b-col>
        <b-form-group>
          <b-button block size="sm" @click="appendPick()">
            선택지추가(+)
          </b-button>
        </b-form-group>
      </b-col>
    </b-row>

    <div :class="intent1_valid_cls">
      <b-row>
        <b-col>출제포인트*</b-col>
      </b-row>
      <div class="multisel_wrapper bspace">
        <multiselect
          v-model="intent1"
          :options="intent_options"
          :custom-label="nameWithLang"
          placeholder="출제포인트1(필수)"
          label="name"
          track-by="name"
        ></multiselect>
      </div>

      <div class="multisel_wrapper bspace">
        <multiselect
          v-model="intent2"
          :options="intent_options"
          :custom-label="nameWithLang"
          placeholder="출제포인트2"
          label="name"
          track-by="name"
        ></multiselect>
      </div>

      <div class="multisel_wrapper bspace">
        <multiselect
          v-model="intent3"
          :options="intent_options"
          :custom-label="nameWithLang"
          placeholder="출제포인트3"
          label="name"
          track-by="name"
        ></multiselect>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import BogiEditor from "@/components/BogiEditor";

export default {
  components: { Multiselect, BogiEditor },
  computed: {
    nocount_qtype3_valid_cls() {
      return this.$store.state.valid.qtype3_nocount;
    },

    ans1_valid_cls() {
      return this.$store.state.valid.ans1;
    },

    picks() {
      return this.$store.state.qtype3_picks;
    },
    q_type_sub() {
      return "2";
      //   return this.$store.state.questionform.q_type_sub;
    },
    intent1_valid_cls() {
      return this.$store.state.valid.intent1;
    },
    intent1: {
      set(val) {
        this.$store.commit("updateIntent1", val);
      },
      get() {
        return this.$store.state.questionform.intent1;
      },
    },
    intent2: {
      set(val) {
        this.$store.commit("updateIntent2", val);
      },
      get() {
        return this.$store.state.questionform.intent2;
      },
    },
    intent3: {
      set(val) {
        this.$store.commit("updateIntent3", val);
      },
      get() {
        return this.$store.state.questionform.intent3;
      },
    },

    intent_value: {
      get() {
        return this.$store.state.intent_value;
      },
      set(val) {
        this.$state.commit("updateIntent", val);
      },
    },
    intent_options() {
      return this.$store.state.intent_options;
    },
    qtype3_valid_cls() {
      return this.$store.state.valid.qtype3;
    },
  },
  methods: {
    appendPick() {
      this.$store.dispatch("appendQType3Pick", "");
    },
    nameWithLang({ d1, d2, d3 }) {
      return `${d1} -> ${d2} -> ${d3}`;
    },
    removePick(pick) {
      if (confirm("삭제하시겠습니까?")) {
        this.$store.dispatch("removeQType3Pick", pick);
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.invalid {
  border: 2px solid red;
  padding: 2px;
  margin: 2px;
}

.qta_wrapper {
  margin-bottom: 15px;
  .multisel_wrapper {
    margin-top: 5px;
  }
  .badgecls {
    padding: 6px;
    margin-bottom: 2px;
  }
  div {
    margin-bottom: 2px;
  }
}
.multiselect--active {
  z-index: 10;
}
.multiselect__content-wrapper {
  z-index: 10;
}

.bspace {
  margin-bottom: 15px;
}
</style>